const CERT_RESULT_CODES = ["00103Y", "00103R", "00104Y", "00104R"];

export function isCertResultMessage(code) {
  return CERT_RESULT_CODES.includes(code);
}

export function isCertResultQuery(query) {
  return !!query && query.newsShow === "1" && query.certResultSource === "1"
    && isCertResultMessage(query.certResultCode)
    && typeof query.bizGuid === "string" && !!query.bizGuid;
}

// 在片段之前追加参数，保留消息原有查询与片段。
export function appendUrlQuery(url, name, value) {
  const hashIndex = url.indexOf("#");
  const base = hashIndex < 0 ? url : url.slice(0, hashIndex);
  const hash = hashIndex < 0 ? "" : url.slice(hashIndex);
  const separator = base.includes("?") ? (/[?&]$/.test(base) ? "" : "&") : "?";
  return base + separator + encodeURIComponent(name) + "=" + encodeURIComponent(value) + hash;
}

export function markCertResultUrl(url, code) {
  return isCertResultMessage(code) && typeof url === "string" && url
    ? appendUrlQuery(appendUrlQuery(url, "certResultCode", code), "certResultSource", "1") : url;
}

export function hasCertResultMarker(url, code) {
  if (typeof url !== "string" || !isCertResultMessage(code)) return false;
  const hashIndex = url.indexOf("#");
  const base = hashIndex < 0 ? url : url.slice(0, hashIndex);
  const queryIndex = base.indexOf("?");
  if (queryIndex < 0) return false;
  const params = new URLSearchParams(base.slice(queryIndex + 1));
  const values = params.getAll("certResultCode");
  const sources = params.getAll("certResultSource");
  return values.length === 1 && values[0] === code && sources.length === 1 && sources[0] === "1";
}
